module.exports = __webpack_public_path__ + "static/old-papers-0fad1eb1c3c1c9cc190af1288ceb30a2.png";